// export const API_BASE_URL =
//   "http://localhost:5700/api/v1/user";

export const API_BASE_URL =
  "https://api.globalinavation.com/api/v1/user";

export const API_PATHS = {


  userFileUpload: "/upload",


  userlogin: "/login",

  userRegister: "/register",
  activateMyAccountFromWallet: "/activateMyAccountFromWallet",
  // profile get 
  getProfile: "/get-profile",
  editProfile: "/edit-profile",
  changePassword: "/changePassword",
  getDashboardSummary: "/getDashboardSummary",
  getDirectReferrals: "/getDirectReferrals",
  getQr: "/get-qr",
  submitJoiningPayment: "/submitJoiningPayment",
  updateProfile: "/updateProfile",
  getMyFundTransfers: "/getMyFundTransfers",
  transferFund: "/transferFund",
  getUserDetailsByUserId: "/getUserDetailsByUserId",
  getMyReferralLevels: "/getMyReferralLevels",
  getMyTeamList: "/getMyTeamList",


  getReferralIncome: "/getReferralIncome",
  getAutoPoolIncome: "/getAutoPoolIncome",
  createWithdrawalRequest: "/createWithdrawalRequest",
  getMyWithdrawals: "/getMyWithdrawals",
  getMySupportIncome: "/getMySupportIncome",


};
